import axios from 'src/app-axios';
import Constants from 'src/constants';

export const timesheets = {
  namespaced: true,
  state: {
    approvedTimesheets: [],
    pendingTimesheets: [],
    allTimesheets: [],
    timesheetDetails: {},
    pendingFilterData: null,
    approvedFilterData: null,
    allFilterData: null,
    payItems: [],
  },
  getters: {
    getApprovedTimesheets (state) {
      return state.approvedTimesheets;
    },
    getPendingTimesheets (state) {
      return state.pendingTimesheets;
    },
    getAllTimesheets (state) {
      return state.allTimesheets;
    },
    getTimesheetDetails (state) {
      return state.timesheetDetails;
    },
    getPendingFilterData (state) {
      return state.pendingFilterData;
    },
    getApprovedFilterData (state) {
      return state.approvedFilterData;
    },
    getAllFilterData (state) {
      return state.allFilterData;
    },
    getPayItems (state) {
      return state.payItems;
    },
  },
  mutations: {
    setApprovedTimesheets (state, data) {
      state.approvedTimesheets = [...state.approvedTimesheets, ...data];
    },
    setPendingTimesheets (state, data) {
      state.pendingTimesheets = [...state.pendingTimesheets, ...data];
    },
    setAllTimesheets (state, data) {
      state.allTimesheets = [...state.allTimesheets, ...data];
    },
    setTimesheetDetails (state, data) {
      state.timesheetDetails = data;
    },
    setPendingFilterData (state, data) {
      state.pendingFilterData = data;
    },
    setApprovedFilterData (state, data) {
      state.approvedFilterData = data;
    },
    clearPendingData (state, data) {
      state.pendingTimesheets = data;
    },
    clearAllData (state, data) {
      state.allTimesheets = data;
    },
    clearApprovedData (state, data) {
      state.approvedTimesheets = data;
    },
    clearPendingFilteredData (state, data) {
      state.pendingFilterData = data;
    },
    clearAllTimesheetData (state, data) {
      state.allTimesheets = data;
    },
    clearApprovedFilteredData (state, data) {
      state.approvedFilterData = data;
    },
    clearAllFilteredData (state, data) {
      state.allFilterData = data;
    },
    setAllFilterData (state, data) {
      state.allFilterData = data;
    },
    setPayItems (state, data) {
      state.payItems = data;
    },
  },
  actions: {
    async fetchApprovedTimesheets ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/timesheets`;
      try {
        const response = await axios.get(url, payload.params);
        commit('setApprovedTimesheets', response.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting approved timesheets.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchAllTimesheets ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/timesheets`;
      try {
        const response = await axios.get(url, payload.params);
        commit('setAllTimesheets', response.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting all timesheets.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchPendingTimesheets ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/timesheets`;
      try {
        const response = await axios.get(url, payload.params);
        commit('setPendingTimesheets', response.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting pending timesheets.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async createTimesheet ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/timesheets`;
      try {
        const response = await axios.post(url, payload.data);
        return response.data;
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in submitting these timesheets',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchTimesheetDetails ({ dispatch, commit }, payload) {
      const url = `api/devices/timesheets/${payload.timesheetId}`;
      try {
        const details = await axios.get(url);
        commit('setTimesheetDetails', details.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting this timesheet details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async updateTimesheet ({ dispatch }, payload) {
      const url = `api/devices/timesheets/${payload.timesheetId}`;
      try {
        await axios.put(url, payload.details);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: exception.response.data.message,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async deleteTimesheet ({ dispatch }, payload) {
      const url = `api/devices/timesheets/${payload.timesheetId}`;
      try {
        await axios.delete(url);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: exception.response.data.message,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async updateTimesheetPermission ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/timesheets`;
      try {
        await axios.put(url, payload.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in updating this timesheet',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchPayItems ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/pay-items`;
      try {
        const response = await axios.get(url);
        commit('setPayItems', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting pay items',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearStoredPendingData ({ commit }) {
      commit('clearPendingData', []);
    },
    clearAllData ({ commit }) {
      commit('clearAllTimesheetData', []);
    },
    clearStoredApprovedData ({ commit }) {
      commit('clearApprovedData', []);
    },
    storeTimesheetPendingFilterData ({ commit }, payload) {
      commit('setPendingFilterData', payload);
    },
    storeTimesheetApprovedFilterData ({ commit }, payload) {
      commit('setApprovedFilterData', payload);
    },
    storeTimesheetAllFilterData ({ commit }, payload) {
      commit('setAllFilterData', payload);
    },
    clearStoredPendingFilteredData ({ commit }) {
      commit('clearPendingFilteredData', null);
    },
    clearStoredApprovedFilteredData ({ commit }) {
      commit('clearApprovedFilteredData', null);
    },
    clearStoredAllFilteredData ({ commit }) {
      commit('clearAllFilteredData', null);
    },
    async takeBreakTime ({ dispatch }, payload) {
      const url = `api/devices/checkin-records/${payload.checkinRecordId}`;
      try {
        await axios.put(url, payload.details);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: exception.response.data.message,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
  },
};
